import { render, staticRenderFns } from "./QualitySealSection.vue?vue&type=template&id=579cccf2&scoped=true&"
import script from "./QualitySealSection.vue?vue&type=script&lang=js&"
export * from "./QualitySealSection.vue?vue&type=script&lang=js&"
import style0 from "./QualitySealSection.vue?vue&type=style&index=0&id=579cccf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579cccf2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
